/**
 * KYC image capture positions (front / back / selfie / liveness).
 */
export var AfriexImageView;
(function (AfriexImageView) {
    AfriexImageView["Back"] = "back";
    AfriexImageView["Front"] = "front";
    AfriexImageView["Selfie"] = "selfie";
    AfriexImageView["Liveness"] = "liveness";
})(AfriexImageView || (AfriexImageView = {}));
//# sourceMappingURL=AfriexImageView.js.map